import Vue from 'vue';
import App from './App.vue';
import store from './store';
import i18n from '@/i18n';
import { Network } from '@/network/Network';
import { Utils } from '@/utils/Utils';
import { PromoComponent } from '@/mainComponent/PromoComponent';
import { Preloader } from '@/preloader';

Preloader.execution();

if (Utils.isInsertIntegration()) {
  const network = new Network();
  const promoComponent = new PromoComponent();
  network.initActions();
  promoComponent.init();
}

Vue.config.productionTip = false;

new Vue({
  // router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#promo_container');
